/*
 * Custom play/pause for product-gallery videos (snippets/product-gallery.liquid).
 * Videos render without native controls. Behaviour splits at the gallery's own
 * 750px breakpoint:
 *
 *   Desktop (>=750px, grid layout):
 *     - hover reveals the .pg-video-toggle play/pause button (click toggles),
 *     - the FIRST video ([data-pg-autoplay]) auto-starts once it scrolls near the
 *       viewport AND the browser is idle (avoids eagerly downloading a 1080p video),
 *     - playing one pauses the others.
 *
 *   Mobile (<750px, swipe slider):
 *     - no button; tap the video itself to play/pause,
 *     - EACH video plays as it scrolls into view and pauses when it leaves.
 *
 *   prefers-reduced-motion: no autoplay anywhere (tap/click still works).
 *
 * Tapping/clicking the <video> works on every device; the button is just the
 * desktop affordance.
 */
(function () {
  var mq = function (q) { return window.matchMedia ? window.matchMedia(q) : { matches: false }; };
  var IS_MOBILE = mq('(max-width: 749px)').matches;
  var REDUCED = mq('(prefers-reduced-motion: reduce)').matches;

  function allVideos() {
    return Array.prototype.slice.call(document.querySelectorAll('video.pg-video'));
  }

  function pauseOthers(current) {
    allVideos().forEach(function (v) {
      if (v !== current && !v.paused) v.pause();
    });
  }

  function play(video, exclusive) {
    video.muted = true; // required for autoplay; keep click-to-play silent too
    if (exclusive) pauseOthers(video);
    var p = video.play();
    if (p && typeof p.catch === 'function') p.catch(function () {});
  }

  function initWrap(wrap) {
    if (wrap.dataset.pgVideoInit) return;
    wrap.dataset.pgVideoInit = '1';

    var video = wrap.querySelector('video.pg-video');
    var btn = wrap.querySelector('.pg-video-toggle');
    if (!video) return;

    video.muted = true;

    function sync() {
      var playing = !video.paused && !video.ended;
      wrap.classList.toggle('is-playing', playing);
      if (btn) btn.setAttribute('aria-label', playing ? 'Pause video' : 'Play video');
    }

    function toggle() {
      // Desktop toggles are exclusive (pause others); on mobile, in-view visibility
      // already governs which one plays, so a manual tap shouldn't pause neighbours.
      if (video.paused) play(video, !IS_MOBILE);
      else video.pause();
    }

    if (btn) btn.addEventListener('click', toggle);
    video.addEventListener('click', toggle);

    ['play', 'playing', 'pause', 'ended'].forEach(function (e) {
      video.addEventListener(e, sync);
    });

    sync();
  }

  // Desktop: defer-autoplay the first video once it's near the viewport + idle.
  function setupDesktopAutoplay() {
    var wrap = document.querySelector('.pg-video-wrap[data-pg-autoplay]');
    if (!wrap) return;
    var video = wrap.querySelector('video.pg-video');
    if (!video) return;

    function fire() {
      if ('requestIdleCallback' in window) {
        requestIdleCallback(function () { play(video, true); }, { timeout: 2000 });
      } else {
        setTimeout(function () { play(video, true); }, 800);
      }
    }

    if ('IntersectionObserver' in window) {
      var obs = new IntersectionObserver(
        function (entries) {
          if (entries[0] && entries[0].isIntersecting) {
            obs.disconnect();
            fire();
          }
        },
        { rootMargin: '200px 0px' }
      );
      obs.observe(wrap);
    } else {
      setTimeout(function () { play(video, true); }, 1500);
    }
  }

  // Mobile: every video plays while in view, pauses while out of view.
  function setupMobileInView() {
    var wraps = Array.prototype.slice.call(document.querySelectorAll('.pg-video-wrap'));
    if (!wraps.length || !('IntersectionObserver' in window)) return;

    var obs = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var video = entry.target.querySelector('video.pg-video');
          if (!video) return;
          if (entry.isIntersecting) {
            play(video, false);
          } else if (!video.paused) {
            video.pause();
          }
        });
      },
      { threshold: 0.5 }
    );

    wraps.forEach(function (w) { obs.observe(w); });
  }

  function boot() {
    document.querySelectorAll('.pg-video-wrap').forEach(initWrap);
    if (REDUCED) return; // no autoplay; manual tap/click still works
    if (IS_MOBILE) setupMobileInView();
    else setupDesktopAutoplay();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
